import OpenDate from '../interfaces/IOpenDate';
import errorHelpers from '../helpers/errors';

class OpenDates {
    static Search = (
        siteId: number,
        start: string,
        end: string,
        accessCode: string | undefined,
        experienceId: number | undefined,
        packageTypeId: number | undefined,
        playerCount: number | undefined,
        signal?: AbortSignal,
        extend?: boolean
    ): Promise<Array<OpenDate>> => {

        return fetch(
            `opendates/${siteId}/${start}/${end}/${accessCode ?? ''}?`
            + `experienceId=${experienceId ? experienceId : ''}`
            + `&packageTypeId=${packageTypeId ? packageTypeId : ''}`
            + `&playerCount=${playerCount ? playerCount : ''}`
            + (extend ? '&extend=true' : ''),
            { signal }
        )
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<Array<OpenDate>>);
    };
}

export default OpenDates;
